module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Paula Graves\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Born in the American South, Paula Graves draws from her experiences with the culture and geography of the region, especially the Appalachian Mountains, to add authentic flavor and unique characters to her tales of romance and mystery."), _c('Br', [_c('Br', [_c('a', {
    attrs: {
      "href": "http://www.paulagraves.com"
    }
  }, [_vm._v("www.paulagraves.com")])])], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Z3dFgx/tc-custom/9781488005855.jpg?1740636877887",
      "alt": "This image is the cover for the book Kentucky Confidential, Campbell Cove Academy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Kentucky Confidential, Campbell Cove Academy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The return of the wife he thought was lost and a baby he never knew existed will make this a Christmas to remember")]), _c('b'), _c('br'), _c('br'), _vm._v("Captain Connor McGinnis has seen a ghost. Staring at a surveillance photo of a Kaziri immigrant, there can be no mistaking that the starkly beautifuland visibly pregnantwoman in a head scarf is his wife, Risa. The woman he presumed was dead after her plane crashed into the ocean. "), _c('br'), _c('br'), _vm._v("Risa McGinnis, relocated by the CIA when they learned of a price on her head, has settled into the guise of a widowed immigrant. Confronting Connor again resurrects sweet memories and a burning passion. But until this unknown enemy is captured, Risa must focus more on Connor's protection than on their attraction. After all, the strength of her marriageand the safety of her babydepends on it\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0